var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3924 8.49461C17.3924 13.4826 12.4243 17.9186 10.1854 19.6644C9.54874 20.1609 8.67912 20.1609 8.04241 19.6644C5.80354 17.9186 0.835449 13.4826 0.835449 8.49461C0.835449 6.29902 1.70764 4.19335 3.26016 2.64084C4.81268 1.08832 6.91834 0.216125 9.11393 0.216125C11.3095 0.216125 13.4152 1.08832 14.9677 2.64084C16.5202 4.19335 17.3924 6.29902 17.3924 8.49461Z",
    fill: "#6638A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11392 11.2541C10.638 11.2541 11.8734 10.0186 11.8734 8.4946C11.8734 6.97057 10.638 5.73511 9.11392 5.73511C7.5899 5.73511 6.35443 6.97057 6.35443 8.4946C6.35443 10.0186 7.5899 11.2541 9.11392 11.2541Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.944c8c4e6fdafd56f37ce1efed478731.svg";
export { ForwardRef as ReactComponent };